export default "__VITE_ASSET__DbljIeNI__"